module.exports = __webpack_public_path__ + "static/media/logo-text-white.02c62d2b.svg";